import React from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';

import { getLocalizedString } from '../../localization/LocalizedString';

class ServiceSiteListItem extends React.Component {
  getIssueStatus() {
    const { translate, issues = [] } = this.props;

    const issueCount = issues.reduce((accumulator, issue) => {
      return accumulator + !issue.ack;
    }, 0);

    if (issueCount === 0) {
      return null;
    }

    return `${issueCount} ${
      issueCount === 1
        ? translate('issue_count.one')
        : translate('issue_count.multiple')}`;
  }

  getPendingStatus() {
    const { translate, session: { isAdmin = false } } = this.props;
    const { internalStatus = '', changeOrders = [] } = this.props;

    if (changeOrders.length === 0 && internalStatus.toLowerCase() !== 'ordered') {
      return null;
    }

    return isAdmin ? translate('requires_action') : translate('order_pending.singular');
  }

  renderAdditionalInfo() {
    const issueStatus = this.getIssueStatus();
    const pendingStatus = this.getPendingStatus();
    const { session: { isAdmin = false } } = this.props;

    if (!issueStatus && !pendingStatus) {
      return null;
    }

    return (
      <div className="row">
        {!!issueStatus
          && <div className={`col-sm-12 ${isAdmin ? 'alert-color' : ''}`}>{issueStatus}</div>}
        {!!pendingStatus
          && <div className="col-sm-12 additional-info-color">{pendingStatus}</div>}
      </div>
    );
  }

  render() {
    const { currentLanguage, additionalInfo = false } = this.props;
    const { serviceSiteId, name } = this.props;

    return (
      <div className="row vertical-middle text-5 normal-color">
        <div className="col-sm-4 text-4 identifier-color">{serviceSiteId}</div>
        <div className="col-sm-4">{getLocalizedString(name, currentLanguage)}</div>
        {!!additionalInfo
          && <div className="col-sm-4">{this.renderAdditionalInfo()}</div>}
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    translate: getTranslate(locale),
    currentLanguage: activeLanguage?.code || 'fi',
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(ServiceSiteListItem);
